import React, { useState, useEffect } from 'react';
import axios from '../api';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  Box,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Alert
} from '@mui/material';

const SellProduct = ({ onSell, closeModal }) => {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState('');
  const [quantity, setQuantity] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    const fetchProducts = async () => {
      const response = await axios.get('/api/products');
      setProducts(response.data);
    };
    fetchProducts();
  }, []);

  const handleSell = async (e) => {
    e.preventDefault();
    if (!selectedProduct || !quantity) {
      setErrorMsg('Please select a product and enter a quantity.');
      return;
    }
    setLoading(true);
    setErrorMsg('');
    try {
      await axios.put(`/api/products/${selectedProduct}/sell`, { quantity });
      setSelectedProduct('');
      setQuantity('');
      onSell();
      closeModal();
    } catch (err) {
      setErrorMsg('Failed to sell product.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open onClose={closeModal} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>Sell Product</DialogTitle>
      <DialogContent dividers>
        {errorMsg && <Alert severity="error" sx={{ mb: 2 }}>{errorMsg}</Alert>}
        <Box component="form" onSubmit={handleSell} sx={{ mt: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth required>
                <InputLabel id="product-label">Select Product</InputLabel>
                <Select
                  labelId="product-label"
                  value={selectedProduct}
                  label="Select Product"
                  onChange={(e) => setSelectedProduct(e.target.value)}
                >
                  <MenuItem value="">Select a product</MenuItem>
                  {products.map((product) => (
                    <MenuItem key={product.id} value={product.id}>
                      {product.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Quantity to Sell"
                type="number"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                required
                fullWidth
              />
            </Grid>
          </Grid>
          <DialogActions sx={{ mt: 2 }}>
            <Button type="submit" variant="contained" color="error" disabled={loading}>
              {loading ? 'Selling...' : 'Sell'}
            </Button>
            <Button variant="outlined" color="secondary" onClick={closeModal} disabled={loading}>Cancel</Button>
          </DialogActions>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SellProduct;
